import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Filter, useFilter, useLoadTags } from '@features/common';
import { ListQuery, ModalRecommend as ModalProgramRecommend } from '@features/programs';
import { LargeHeader, Nav, NavTab, useTabs } from '@shared/ui';
import { ModalLarge } from 'library/components/common';
import * as st from './styles.module.scss';

const tabs: { [x: string]: string } = {
  all: 'Все',
  favorite: 'Избранные',
  my: 'Мои',
};

export const ModalRecommend: React.FC = () => {
  const navigate = useNavigate();
  const { code, tabCode = '' } = useParams<{
    code: string;
    tabCode: string;
  }>();
  const { tab, chooseTab } = useTabs('all');
  const { tags, selectedTags, onTagChange, search, onSearch } = useFilter();
  const onClose = () => navigate(`/clients/${code}?onClose=reload`);
  useLoadTags(tabCode);

  const listKey = `${tab}${search}${code}${JSON.stringify(selectedTags)}`;
  const listParams = { search: search, tags: selectedTags };

  return (
    <ModalLarge disableHeader isOpen onRequestClose={onClose}>
      <LargeHeader title="Рекомендовать программу" onClose={onClose} />
      <div className={st.nav}>
        <Nav>
          <div>
            <div>
              {Object.keys(tabs).map((key) => (
                <NavTab
                  isActive={key === tab}
                  key={key}
                  onClick={() => {
                    chooseTab(key);
                    onSearch('');
                    onTagChange([]);
                  }}
                >
                  {tabs[key]}
                </NavTab>
              ))}
            </div>
          </div>
          <div>
            <Filter tags={tags} selected={selectedTags} onChange={onTagChange} />
          </div>
        </Nav>
      </div>
      <div className={st.list}>
        <ListQuery tabName={tab} key={listKey} params={listParams} />
      </div>
      <ModalProgramRecommend />
    </ModalLarge>
  );
};
